var _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeAdvantage1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#4468EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 28.9189C36.5 33.3105 33.0123 36.8378 28.75 36.8378C24.4877 36.8378 21 33.3105 21 28.9189C21 24.5273 24.4877 21 28.75 21C33.0123 21 36.5 24.5273 36.5 28.9189Z",
    stroke: "#F8F8FF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.052 34.6546L35.6984 34.3011L34.9913 35.0082L35.3449 35.3617L36.052 34.6546ZM39.638 39.6549C39.8333 39.8501 40.1499 39.8501 40.3451 39.6549C40.5404 39.4596 40.5404 39.143 40.3451 38.9478L39.638 39.6549ZM35.3449 35.3617L39.638 39.6549L40.3451 38.9478L36.052 34.6546L35.3449 35.3617Z",
    fill: "#F8F8FF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeAdvantage1);
export default __webpack_public_path__ + "static/media/home-advantage-1.8045046005d529ff5cd6f6909c6d5080.svg";
export { ForwardRef as ReactComponent };